export default __webpack_public_path__ + "maps-examples-annotation-views-thumbnail-480-24759f473eae3495886b44d0c5c89e0a.png";